'use strict';

import $ from 'jquery';

export default class BackToTop {
	constructor() {
		this.$backToTop = $('button.back-to-top');
	}

	init() {
		if($('.relative-header__ctas--share').length) {
			this.$backToTop.addClass('offset');
		}
		
		this.$backToTop.on('click', (e) => {
			e.preventDefault();
			$('html, body').animate({scrollTop: 0}, 600);
		});
	}
}
